import { combineReducers } from 'redux';
import usersReducer from './users/usersReducer';
import commonReducer from './commonReducer';
import reportsReducer from './reports/reportsReducer';
import postsReducer from './posts/postsReducer';
import splashScreenReducer from './splashscreens/splashScreenReducer'
import mobileAppBannerReducer from './mobileappbanners/MobileAppBannerReducer';
import AppVersionsReducer from './appversions/AppVersionsReducer';
import rolesReducer from './roles/rolesReducer'
import permissionsReducer from './permissions/permissionsReducer'
import asuiteAppReducer from './asuiteapps/asuiteAppsReducer';

const rootReducer = combineReducers({
  posts: postsReducer,
  users: usersReducer,
  common: commonReducer,
  reports: reportsReducer, 
  splashscreens: splashScreenReducer,
  mobileappbanners: mobileAppBannerReducer,
  appversions: AppVersionsReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
  asuiteapps: asuiteAppReducer
});

export default rootReducer